
<template>
  <div id="page-approval-list">
    <vs-card>



      <template class="" title="Filtros">
        <div class="vx-row mt-2 mb-2 ml-2 mr-2">
          <div class="vx-col w-1/4  mb-5">
            <label style="font-family: 'Arial', sans-serif; font-size: 13px;" for="">Data Aprovação</label>
            <vs-input style="font-family: 'Arial', sans-serif; font-size: 13px;" class="w-full" @change="getVacations" icon-pack="feather"
              icon-no-border v-model="start_date" type="date" />
          </div>

          <div class="vx-col w-1/4 mb-5">
            <label for="" style="font-family: 'Arial', sans-serif; font-size: 13px;">Status</label>
            <v-select placeholder="Nada Selecionado" :options="statusOptions" label="label" @input="getVacations"  v-model="status"
              style="font-family: 'Arial', sans-serif; font-size: 13px;  height: 40px;"></v-select>
          </div>



        </div>
      </template>

      <vs-table search stripe :data="vacations.data" :max-items="paginate">

        <template slot="thead">
          <vs-th style="background-color: #ebe9f1;" sort-key="employee">Funcionario</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="department">Departamento</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="department">Data Inicio</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="department">Data Fim</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="start_date">Data de Aprovação</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="start_date">Aprovado Por</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="duration">Comentario</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="status">Estado</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, index) in data" :key="index">
            <vs-td>{{ item.scheduling.employee.user.name }} {{ item.scheduling.employee.user.surname }}</vs-td>
            <vs-td>{{ item.scheduling.employee.department.name }}</vs-td>
            <vs-td>{{ item.scheduling.start_date }}</vs-td>
            <vs-td>{{ item.scheduling.end_date }}</vs-td>
            <vs-td>{{ formatDate(item.approval_date) }}</vs-td>
            <vs-td>{{ item.approver.name}} {{ item.approver.surname}}</vs-td>
            <vs-td>{{ item.comment }}</vs-td>
            <vs-td>
              <vs-pill style="padding: 5px; border-radius: 4px; font-family: 'Arial', sans-serif; font-size: 12px; "
                :class="getStatusClass(item.status)">{{ getStatusName(item.status) }}</vs-pill>
            </vs-td>

<!--
            <vs-td>{{ item.employee }}</vs-td>
            <vs-td>{{ item.department }}</vs-td>
            <vs-td>{{ item.start_date }}</vs-td>
            <vs-td>{{ item.end_date }}</vs-td>
            <vs-td>{{ getTypeText(item.type) }}</vs-td>
            <vs-td>{{ item.reason }}</vs-td>
            <vs-td>
              <vs-pill style="padding: 5px; border-radius: 4px; font-family: 'Arial', sans-serif; font-size: 12px; "
                :class="getStatusClass(item.status)">{{ getStatusName(item.status) }}</vs-pill>
            </vs-td> -->

          </vs-tr>
        </template>



      </vs-table>


      <div class="flex justify-between items-center">
        <label style="font-family: 'Arial', sans-serif; font-size: 13px; margin-left: 5px;" class="font-light">Mostrando
          {{ total }} de {{ perPage }} </label>
        <vs-pagination class="flex-1" style="margin-top: 10px;" v-model="currentPage" :total="lastPage" :per-page="perPage" @change="getVacations"
          :size="size" color="primary" :gradient="gradient" :rounded="rounded" :dense="dense"></vs-pagination>
      </div>


      <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    </vs-card>



    <vs-popup class="holamundo" title="Aprovar Agendamento" v-model="popupApprove" :active.sync="popupApprove">

      <b-card-text>
        Ao autorizar as férias para um funcionário, você está dando o consentimento e aprovação para que ele tire um período de descanso programado. Isso implica que o funcionário terá direito a afastar-se das suas atividades de trabalho durante o período especificado como férias.
      </b-card-text>

      <div class="mt-5">
        <div class="vx-row ">
            <div class="vx-col sm:1/2 w-full mb-2">
              <div class="vx-col w-full">
                <label class="text-sm font-bold">Funcionario</label>

                <vs-input  class="w-full mt-2 mb-0" disabled v-if="selectedItem" v-model="selectedItem.employee.user.name" />

              </div>
            </div>
        </div>

        <div class="vx-row ">
            <div class="vx-col sm:1/2 w-full mb-2">
              <div class="vx-col w-full">
                <label class="text-sm font-bold">Data Inicio</label>

                <vs-input  class="w-full mt-2 mb-0" disabled v-if="selectedItem" v-model="selectedItem.start_date" />

              </div>
            </div>
        </div>


        <div class="vx-row ">
            <div class="vx-col sm:1/2 w-full mb-2">
              <div class="vx-col w-full">
                <label class="text-sm font-bold">Data Fim</label>

                <vs-input  class="w-full mt-2 mb-0" disabled v-if="selectedItem"  v-model="selectedItem.end_date " />

              </div>
            </div>
        </div>




        <div class="vx-row">
            <div class="vx-col sm:1/2 w-full mb-2">
              <div class="vx-col w-full">
                <label class="text-md font-bold">Parecer </label>
                <div class="sub-label-container">
                  <span><small class="text-sm text-gray-500">Por favor escreva o parecer da aprovação.</small></span>
                </div>
                <vs-textarea style="margin-top: 5px;" class="w-full" v-model="reason" name="Motivo"
                  v-validate="'required'"></vs-textarea>

              </div>
            </div>
          </div>

      </div>


      <div class="flex flex-wrap items-center flex-start">
        <vs-button type="filled" class="ml-auto mt-2" @click="approveVacation">Aprovar</vs-button>
        <vs-button class="ml-4 mt-2" type="filled" @click="cancelPopupApprove" color="danger">Cancelar</vs-button>
      </div>
    </vs-popup>



  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import http from '../../../../../http-common'
import http1 from '../../../../../http1-common'
// Store Module

// Cell Renderer



export default {
  components: {
    AgGridVue,
    vSelect,


  },
  data() {
    return {
      popupApprove: false,
      vacations: [],
      selectedItem: '',
      reason:'',
      start_date:'',
      end_date:'',
      status: '',
      statusOptions: [
        { label: "Aprovado", value: "approved" },
        { label: "Pendente", value: "pending" },
        { label: "Rejeitado", value: "rejected" },

      ],
      data: [
        {
          employee: 'Edy Barrote',
          department: 'Software Development',
          start_date: '2023-01-05',
          end_date: '2023-01-15',
          duration: '10 dias',
          type: 'Singular',
          status: 'Recusado',
          reason: 'Motivo'
        },
        {
          employee: 'Kleyton',
          department: 'Software Development',
          start_date: '2023-01-15',
          end_date: '2023-01-20',
          duration: '5 dias',
          type: 'Colectivas',
          status: 'Aceite',
          reason: 'Motivo 2'
        },

      ],
      lastPage: 0,
      currentPage: 1,
      perPage: 0, // Number of items to display per page
      total: 0, // Total number of items
      size: 'normal', // Pagination size
      gradient: false, // Enable gradient effect
      rounded: false, // Enable rounded corners
      dense: false, // Use compact pagination style
    }
  },

  mounted() {
    this.initialize();
  },


  computed: {

  },


  methods: {
    initialize() {
      this.getUser();
      this.getVacations();
    },
    getUser() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })



      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          type: 1
        }
      };

      http
        .get("/users/users", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.users = result.data.Users.reverse();

          // alert("2")
        })
        .catch((error) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    getVacations() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })



      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          approval_date: this.start_date,
          status: this.status != null ? this.status.value : '',
          page: this.currentPage,
          paginate: this.paginate,
        }
      };

      http1
        .get("/vacations/approvals", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.vacations = result.data;

          this.currentPage = result.data.current_page
          this.perPage = result.data.per_page
          this.total = result.data.total
          this.lastPage = result.data.last_page

          console.log('Ferias', this.vacations);
          // alert("2")
        })
        .catch((error) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    clickApproveHandler(item) {
      // Display the popup model and pass the data from the current row
      this.popupApprove = true;
      this.selectedItem = item; // Store the current row data in a variable for display in the popup
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: "numeric", month: "long", year: "numeric" };
      return date.toLocaleDateString("pt-PT", options); // Adjust the locale as needed
    },

    getStatusClass(status) {
      if (status === 'approved') {
        return 'vs-pill-success';
      } else if (status === 'pending') {
        return 'vs-pill-warning';
      } else if (status === 'rejected') {
        return 'vs-pill-danger';
      } else if (status === 'canceled') {
        return 'vs-pill-dark';
      }

      else {
        return '';
      }
    },

    getStatusName(status) {
      if (status === 'approved') {
        return 'Aprovado';
      } else if (status === 'pending') {
        return 'Pendente';
      } else if (status === 'rejected') {
        return 'Rejeitado';
      } else if (status === 'canceled') {
        return 'Cancelado';
      }

      else {
        return '';
      }
    },

    getTypeClass(type) {
      if (type === 'Singular') {
        return 'vs-pill-primary';
      } else if (type === 'Colectivas') {
        return 'vs-pill-secundary';
      } else {
        return '';
      }
    },

    getTypeText(type) {
      if (type === 'scheduled') {
        return 'Agendado';
      } else if (type === 'anticipated') {
        return 'Antecipado';
      } else if (type === 'anticipated') {
        return 'Adiado';
      } else {
        return '';
      }
    },
    cancelPopupApprove() {
     this.popupApprove = false;
    },
    approveVacation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          setTimeout(() => {
            this.$vs.loading.close()
          }, 3000);
          let token = localStorage.getItem("token");
          let config = {
            headers: {
              authorization: "Bearer " + token,
            },
          };
          const data = {
            comment: this.reason,
          };

          this.$validator.validateAll();
          http1
            .post("/vacations/schedule/approve/employee/" + this.selectedItem.id, data, config)
            .then((success) => {
              success;
              this.reason = '';
              this.$vs.loading.close();
              this.popupApprove =false;
              this.$vs.notify({
                title: "Sucesso",
                text: "Ferias aprovadas com sucesso",
                color: "success",
                position: "top-right",
              });

              setTimeout(() => {
                this.$router.push('/pages/holiday/schedule/intercalar/list');
              }, 5000);

            })
            .catch((error) => {
              error;
              console.log("Error", error)
                this.err = error.response.data
                this.$vs.loading.close()
                this.$vs.notify({
                  title: "Erro",
                  text: this.err.message,
                  color: "danger",
                  position: "top-right",
                })

            });


        } else {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Preencha todos campos obrigatorios",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        }
      })
    },




  }
}

</script>

<style>
/* Add styles for the pill colors */
.vs-pill-success {
  background-color: #28CF6F;
  color: white;
  padding: 5px;
}

.vs-pill-danger {
  background-color: #EA5455;
  color: white;
}

.vs-pill-warning {
  background-color: rgb(255, 159, 67);
  color: white;
}

.vs-pill-dark {
  background-color: rgb(168, 170, 174);
  color: white;
}

.vs-pill-primary {
  background-color: #00CFE8;
  color: white;
}

.vs-pill-secundary {
  background-color: #A8AAAC;
  color: white;
}
</style>

